import React, { useContext } from 'react';
import { useTheme } from 'ThemeContext';
import { FormattedMessage } from 'react-intl';
import { AppSettingsContext } from 'AppSettingsContext';

import {
  Item,
  ItemExternal,
  Imagebox,
  Image,
  Text,
  TextBox,
  Arrow,
  ReadMore
} from './WidgetItem.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import IMAGE_PLACEHOLDER from 'assets/Images/placeholder-50x50.png';

function WidgetItem({
  isCollection = false,
  isFirstCollection = false,
  isLastCollection = false,
  data = {}
}) {
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  const renderItemInner = data => {
    const regExp = new RegExp('(.*)(.jpg|.jpeg|.png)$');
    let currentImage = data.thumbnail || data.image;
    let currentImageMatch;
    if (currentImage) {
      currentImageMatch = currentImage.match(regExp);
      if (currentImageMatch && currentImageMatch[1] && currentImageMatch[2])
        currentImage = `${currentImageMatch[1]}_${theme.widgetItem.image.width}x${theme.widgetItem.image.height}${currentImageMatch[2]}`;
    }

    return (
      <>
        <Imagebox theme={theme.widgetItem.imagebox}>
          <Image
            theme={theme.widgetItem.image}
            src={currentImage || IMAGE_PLACEHOLDER}
            loading='lazy'
            alt={data.title}
          />
        </Imagebox>
        <TextBox>
          <Text theme={theme.widgetItem.text}>
            {data.title}
            <Arrow theme={theme.widgetItem.arrow}>
              <FontAwesomeIcon icon={theme.widgetItem.arrow.faIcon} />
            </Arrow>
          </Text>
          {appSettings.theme === 4 ? (
            <ReadMore theme={theme.widgetItem.readMore}>
              {' '}
              <FormattedMessage id='WIDGET_LIST.READ_MORE' />{' '}
            </ReadMore>
          ) : (
            ''
          )}
        </TextBox>
      </>
    );
  };

  return (
    <>
      {(data.slug && /(http(s?)):\/\//gi.test(data.slug)) ||
      (data.url && /(http(s?)):\/\//gi.test(data.url)) ||
      data.url_outside ? (
        <ItemExternal
          theme={theme.widgetItem.item}
          title={data.title}
          href={data.slug || data.url || data.url_outside}
          target={
            data._blank || data.url_blank || data.url_outside_blank
              ? '_blank'
              : '' || data.target || ''
          }
          rel={
            data.nofollow || data.url_nofollow || data.url_outside_nofollow
              ? 'nofollow'
              : '' || data.rel || ''
          }
          isCollection={isCollection}
          isFirstCollection={isFirstCollection}
          isLastCollection={isLastCollection}
        >
          {renderItemInner(data)}
        </ItemExternal>
      ) : (
        <Item
          theme={theme.widgetItem.item}
          title={data.title}
          smooth
          to={data.slug && data.slug[0] === '/' ? data.slug : `/${data.slug}`}
          isCollection={isCollection}
          isFirstCollection={isFirstCollection}
          isLastCollection={isLastCollection}
        >
          {renderItemInner(data)}
        </Item>
      )}
    </>
  );
}

export default WidgetItem;
